/* eslint-disable */
export default {
  unknown: 'Inconnu',
  anonymous: 'Anonyme',
  activeCalls: 'Tous les appels',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCalls"@#@ @source: @#@"All Calls"@#@
